import { SelectorSpot, SpotResponse, SpotRole, SpotsResponse, SpotType } from './spotSelectorTypes';

export function parseSpots(response: SpotsResponse, networkId: string): SelectorSpot[] {
  const { 'moderation-viewer': moderationViewer = [], moderator = [], owner = [] } = response;

  const normalizedModerationViewer = moderationViewer.map(createMap('viewer', 'moderationViewer'));

  const normalizedModerator = moderator.map(createMap('moderator', 'moderator'));
  const normalizedOwner = owner.map(createMap('admin', 'admin'));

  const spotsWithPossibleDuplicates = [
    ...normalizedOwner,
    ...normalizedModerator,
    ...normalizedModerationViewer
  ].filter(({ name }) => Boolean(name));

  const spotsWithoutDuplicates: SelectorSpot[] = [];
  const map: Record<string, boolean> = {};

  spotsWithPossibleDuplicates.forEach(spot => {
    if (!map[spot.id]) {
      map[spot.id] = true;
      spotsWithoutDuplicates.push(spot);
    }
  });

  const spotsFromNetwork = spotsWithoutDuplicates.filter(spot => spot.networkId === networkId);
  const spotsFromOtherNetwork = spotsWithoutDuplicates.filter(spot => spot.networkId !== networkId);

  return [...spotsFromNetwork, ...spotsFromOtherNetwork];
}

function createMap(role: SpotRole, type: SpotType) {
  return function (spot: SpotResponse): SelectorSpot {
    const { network_id, name, id } = spot;

    return {
      id,
      name,
      networkId: network_id,
      role,
      type
    };
  };
}

export const getInitialSpotIdBeNetwork = (spots: SelectorSpot[], networkId: string): string => {
  const spot = spots.find(spot => spot.networkId === networkId);

  return spot ? spot.id : '';
};
